import { useAnalytics } from '@ecosystem/newron-client-lib';
import { SortingOptionsType } from '@components/design/migrated/Table';
import { useSelector } from 'react-redux';
import { useInViewTracking } from '@utils/hook/tracking/UseInViewTracking';
import {
  PAGE_ELEMENT_VIEW_TRACKING_TITLE,
  PageElementViewTrackingParam,
} from '@utils/page-analytics/model/PageElementViewedTracking';
import { getPageTypeWithPageName, SubSection } from '@utils/pageConfig/Types';
import { PerformanceAnalysisView, PerformanceAnalysisViewMapping } from './Types';
import { usePageConfig } from '@utils/pageConfig/PagesConfigContext';

export const useInViewTrackingForPerformanceAnalysis = (
  view: PerformanceAnalysisView,
  elementKpi: string | undefined,
  hasData: boolean,
  elementName: string,
  subSection: SubSection,
  elementSort?: SortingOptionsType,
) => {
  const sideFiltersState = useSelector((state: any) => state.sideFilters);
  const retailerClientState = useSelector((state: any) => state.retailerClient);
  const mainFiltersState = useSelector((state: any) => state.mainFilters);
  const { track } = useAnalytics();
  const pagesConfig = usePageConfig();
  const { pageName } = pagesConfig;
  const createParam: () => PageElementViewTrackingParam = () => {
    return {
      eventTitle: PAGE_ELEMENT_VIEW_TRACKING_TITLE,
      sideFilters: sideFiltersState.appliedFilters,
      retailerClientState,
      track,
      pageType: getPageTypeWithPageName(pageName),
      pageName,
      componentName: elementName,
      elementType: PerformanceAnalysisViewMapping[view],
      elementKpi,
      elementSort,
      mainFilterState: mainFiltersState,
      hasData,
      access: pagesConfig.access,
      subSection,
    };
  };
  const { ref } = useInViewTracking(createParam, {
    threshold: 0.2,
    triggerOnce: true,
  });
  return { ref };
};
